import { Col, Label } from '../ui';

export type LabeledInfoProps = {
  label: string;
  value: React.ReactNode | undefined | null;
};

export const LabeledInfo = ({ label, value }: LabeledInfoProps) => (
  <Col gap1 className="@LabeledInfo">
    <Label className={'opacity-50'}>{label}</Label>
    <div>{value || '–'}</div>
  </Col>
);
